import React from "react";
import { Select, MenuItem } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

export default function SchoolYearSelect({
  years,
  value,
  onChange,
  sx,
  ariaLabel = "School year",
  variant = "standard",
  fullWidth = false,
  size,
}) {
  if (!years?.length) return null;

  const isStandard = variant === "standard";

  return (
    <Select
      variant={variant}
      disableUnderline={isStandard}
      fullWidth={fullWidth}
      size={size}
      value={value ?? ""}
      onChange={onChange}
      IconComponent={ArrowDropDownIcon}
      inputProps={{ "aria-label": ariaLabel }}
      sx={{
        ...(isStandard && {
          fontWeight: "bold",
          fontSize: 20,
          color: "#000000",
        }),
        ...sx,
      }}
    >
      {years.map((sy) => (
        <MenuItem key={sy.id} value={String(sy.id)}>
          {sy.name}
        </MenuItem>
      ))}
    </Select>
  );
}
